/* eslint-disable */
export const protobufPackage = 'com.celertech.marketdata.api.enums.marketdataupdatetype';

export enum MarketDataUpdateType {
    INCREMENTAL = 1,
    FULL_SNAPSHOT = 2,
    UNRECOGNIZED = -1
}
